import React from "react";
import SafeImage from "./SafeImage";

// Author registry — expandable. Match on lowercased normalized author string.
const AUTHORS = {
  reel: {
    name: "Réel Mambe Mola",
    role: "Journaliste · Rédacteur web polyvalent · Community Manager",
    photo:
      "https://customer-assets-cm19k8pv.emergentagent.net/job_gai-editorial/artifacts/eyz8kjxz_599e49ce-2ad3-41e1-b1f6-5cb642dc0a47.jpeg",
    slug: "reel-mambe-mola",
  },
};

function matchAuthor(rawAuthor) {
  if (!rawAuthor) return null;
  const s = rawAuthor.toLowerCase();
  if (s.includes("réel") || s.includes("reel") || s.includes("mambe")) return AUTHORS.reel;
  return null;
}

export default function AuthorCard({ author }) {
  const a = matchAuthor(author);
  if (!a) return null;

  return (
    <div
      className="mt-12 p-6 flex items-center gap-5"
      style={{ background: "var(--gai-grey-50)", border: "1px solid var(--gai-grey-200)" }}
      data-testid="author-card"
    >
      <div
        className="shrink-0 relative"
        style={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          overflow: "hidden",
          border: "2px solid var(--gai-red)",
        }}
      >
        <SafeImage
          src={a.photo}
          alt={a.name}
          fallbackLabel={a.name.split(" ").map((w) => w[0]).join("").slice(0, 2)}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="flex-1 min-w-0">
        <div
          className="text-[0.62rem] font-bold tracking-[0.24em] uppercase mb-1"
          style={{ color: "var(--gai-red)" }}
        >
          Signé par
        </div>
        <div
          className="serif text-xl leading-tight"
          style={{
            color: "var(--gai-black)",
            fontFamily: "'Playfair Display', serif",
            fontWeight: 700,
          }}
          data-testid="author-card-name"
        >
          {a.name}
        </div>
        <div className="text-sm mt-1" style={{ color: "var(--gai-grey-700)" }}>
          {a.role}
        </div>
      </div>
    </div>
  );
}
